/**
 *
 * Spinner
 *
 */
import { memo } from 'react';
import styled, { keyframes } from 'styled-components/macro';

interface Props {
  small?: boolean;
  size?: string;
}

export const Spinner = ({ size }: Props) => (
  <div className="fixed top-0 left-0 w-full h-full z-9999">
    <div className={`absolute z-9999 top-1/2 left-1/2`}>
      <Svg viewBox="-24 -24 48 48" width={size} height={size}>
        <Circle cx="0" cy="0" r="20" fill="none" strokeWidth="4"></Circle>
      </Svg>
    </div>
  </div>
);

const speed = 1.5;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 0, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 150;
    stroke-dashoffset: -24;
  }
  100% {
    stroke-dasharray: 0, 150;
    stroke-dashoffset: -124;
  }
`;

const Svg = styled.svg<Props>`
  animation: ${rotate} ${speed * 1.75}s linear infinite;
  height: ${p => p.size};
  width: ${p => p.size};
  transform-origin: center;
`;

const Circle = styled.circle`
  animation: ${dash} ${speed}s ease-in-out infinite;
  stroke: white;
  stroke-linecap: round;
`;
